var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "29px",
    viewBox: "0 0 25 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 20") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Heades-new",
    transform: "translate(-1077.000000, -1557.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(1077.000000, 1557.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,21 L19,18 L17,18 L17,21 L14,21 L14,23 L17,23 L17,26 L19,26 L19,23 L22,23 L22,21 L19,21 Z M18,29 C14.1340068,29 11,25.8659932 11,22 C11,18.1340068 14.1340068,15 18,15 C21.8659932,15 25,18.1340068 25,22 C25,25.8659932 21.8659932,29 18,29 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "doc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2724591,23 L18,15.6114729 L18,6.1486877 L15.3955468,3.79664063 L11.7097073,1 L1,1 L1,23 L11.2724591,23 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05175781,9.59716797 L13.9723424,9.59716797",
    id: "Path-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05175781,13.597168 L11.3813477,13.597168",
    id: "Path-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05175781,17.597168 L13.9723424,17.597168",
    id: "Path-36"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAdd);
export default __webpack_public_path__ + "static/media/ico_add.bb0889728615f013b3fa2be4a36fe507.svg";
export { ForwardRef as ReactComponent };